import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { Option } from '@zuto/atoms'
import MenuItem from '@mui/material/MenuItem'
import styles from '../MuiInput.style'
import selectStyles from '../MuiSelect.style'

export interface MuiSelectProps {
  data?: Option[]
  defaultValue?: string
  id: string
  isSelectedHandler?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  label: string
  name?: string
  onBlurHandler?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  onChangeHandler?: (e: SelectChangeEvent) => void
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  onKeyPressHandler?: React.KeyboardEventHandler<HTMLInputElement>
  testId?: string
  value?: string | number
  variant?: 'filled' | 'outlined'
}

const MuiSelect = (
  {
    data,
    defaultValue,
    id,
    label,
    name,
    onChangeHandler,
    testId,
    variant,
    ...props
  }: MuiSelectProps
): JSX.Element => {
  return(
  <>
    <FormControl
      className={[
        variant === 'outlined' ? 'outlined' : 'filled', 'MuiSelect-wrapper'
      ].join(' ')}
      data-testid="muiselect-wrapper"
      variant={variant}
      fullWidth
      sx={styles}
    >
      <InputLabel id={id}>{label}</InputLabel>
      <Select
        defaultValue={defaultValue}
        labelId={id}
        name={name}
        onChange={onChangeHandler}
        inputProps={{
          ...props,
          'data-testid': testId
        }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
        sx={(testId !== 'address-dropdown') ? selectStyles : null}
      >
        {data && data.map((item) => (
          <MenuItem divider key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>

    </FormControl>
  </>
)}

export default MuiSelect
